import React, { useState, useEffect } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import CustomSelect from "./CustomSelect";
import { BsFillSendFill } from "react-icons/bs";
import usePostData from "../Custom-Hooks/usePostData";
import { Link } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";
import SuccessPopup from "./SuccessPopup";

const DataTable = ({ headingText = "", headers, data }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [sortedData, setSortedData] = useState([...data]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [notifyData, setNotifyData] = useState(null);
  const [notifyDescription, setNotifyDescription] = useState("");
  const [updatedNotifyData, setUpdatedNotifyData] = useState(null);
  const [sentStatus, setSentStatus] = useState({});
  const [showSentDetails, setShowSentDetails] = useState(null);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const initialSentStatus = {};
    data.forEach((row, index) => {
      initialSentStatus[row.id] = row.isMailSent || false;
    });
    setSentStatus(initialSentStatus);
    setSortedData([...data]);
    setCurrentPage(1);
  }, [data]);

  useEffect(() => {
    if (data && data.length > 0 && !sortConfig.key) {
      setSortConfig({
        key: Object.keys(data[0])[0],
        direction: "asc",
      });
    }
  }, [data]);

  const handleSort = (header, index) => {
    const key = Object.keys(data[0])[index];
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedArray = [...sortedData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sortedArray);
    setSortConfig({ key, direction });
  };

  const openPdfPopup = (pdfUrl) => {
    setSelectedPdf(pdfUrl);
  };

  const closePdfPopup = () => {
    setSelectedPdf(null);
  };

  const handleCloseModal = () => { };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNotify = (rowData) => {
    if (!sentStatus[rowData.id]) {
      setNotifyData({ ...rowData, description: "" });
      setNotifyDescription("");
    } else {
      setShowSentDetails(rowData);
    }
  };

  const { post, isLoading, error } = usePostData(
    `${baseUrl}/email/send-email`
  );


  const handleSendNotify = async () => {
    const filteredData = {};
    headers.forEach(header => {
      filteredData[header] = notifyData[header];
    });
    filteredData.description = notifyDescription;

    const dataToSend = {
      ...filteredData,
      id: notifyData.id,
    };

    setUpdatedNotifyData(dataToSend);

    try {
      const res = await post(dataToSend);

      if (res && res.status >= 200 && res.status < 300) {
        setSentStatus((prevState) => ({
          ...prevState,
          [notifyData.id]: true,
        }));
        setSuccessMessage("Notification Sent Successfully!");
        setShowSuccessPopup(true);
      } else {
        console.error('Failed to send email:', res ? res.statusText : "Unknown error");
        setSuccessMessage("Failed to send notification");
        setShowSuccessPopup(true);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setSuccessMessage("Error sending notification");
      setShowSuccessPopup(true);
    }

    setNotifyData(null);
    setNotifyDescription("");
  };
 
  const renderSendButton = (row) => {
    const isSent = sentStatus[row.id];

    return (
      <div
        style={{
          color: isSent ? "#999" : "#28a745",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
        }}
        onClick={() => handleNotify(row)}
      >
        <BsFillSendFill size={12} />
        <span
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: isSent ? "#999" : "#28a745",
          }}
        >
          {isSent ? "Sent" : "Send"}
        </span>
      </div>
    );
  };

  return (
    <div>
      <div className="py-1 fnt14 fw-600">
        {headingText} - {data?.length}
      </div>
      <hr className="mt-0" />
      {data?.length > 0 && (
        <>

          <div className="table-responsive" style={{ overflowX: 'auto' }}>
            <table className="analysis-modal-table table mt-3" style={{
              tableLayout: 'auto',
              width: '100%'
            }}>
              <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      onClick={() => handleSort(header, index)}
                      style={{
                        cursor: "pointer",
                        whiteSpace: 'nowrap',
                        minWidth: header === 'Description' ? '300px' : 'auto'
                      }}
                    >
                      {header}
                      {sortConfig.key === Object.keys(data[0])[index]
                        ? sortConfig.direction === "asc"
                          ? " ⏶"
                          : " ⏷"
                        : ""}
                    </th>
                  ))}
                  <th style={{ width: '120px', whiteSpace: 'nowrap' }}>Notify Change</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((row, rowIndex) => (
                  <tr key={`${rowIndex}-${row.id}-${sentStatus[row.id]}`}>
                    {headers.map((header, colIndex) => (
                      <td
                        key={colIndex}
                        style={{
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          maxWidth: header === 'Description' ? '400px' : '200px',
                          verticalAlign: 'top'
                        }}
                      >
                        {colIndex === 0 ? (
                          <div>
                            <Link
                              to={{
                                pathname: "/dashboard/drawing",
                                search: `?imageUrl=${encodeURIComponent(row.imageURL)}`,
                              }}
                              className="decoration-none"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {row[header].split('\n')[0]}
                            </Link>
                            {row[header].includes('\n') && (
                              <div style={{
                                whiteSpace: 'pre-line',
                                fontSize: '0.8em',
                                color: '#666',
                                marginTop: '2px'
                              }}>
                                {row[header].split('\n').slice(1).join('\n')}
                              </div>
                            )}
                          </div>
                        ) : header === 'Location' ? (
                          <div style={{ whiteSpace: 'pre-line' }}>
                            {row[header]}
                          </div>
                        ) : (
                          <span>{row[header] || "-"}</span>
                        )}
                      </td>
                    ))}
                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                      {renderSendButton(row)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              <label className="fnt12 fw-500 text-secondary">
                Rows per page:
              </label>
              <CustomSelect
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
                options={[10, 25, 50, 100]}
              />
            </div>
            <div>
              <MdKeyboardArrowLeft
                size={24}
                style={{
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
              />

              <span className="mx-2 fnt12 fw-500 text-secondary">
                Page {currentPage} of {totalPages}
              </span>

              <MdKeyboardArrowRight
                size={24}
                style={{
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
                onClick={() =>
                  currentPage < totalPages && handlePageChange(currentPage + 1)
                }
              />
            </div>
          </div>
        </>
      )}
      {data?.length === 0 && (
        <div
          style={{ minHeight: "200px" }}
          className="d-flex align-items-center justify-content-center fnt12"
        >
          No Issues found
        </div>
      )}

      <div
        className="modal fade"
        id="equipment-issue-pdf"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title fnt14 fw-500"
                id="staticBackdropLabel"
              >
                Equipment Issue
              </div>
              <button
                type="button"
                className="btn-close px-1"
                data-bs-dismiss="modal"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">Equipment Issue</div>
          </div>
        </div>
      </div>

      {/* Send Notification Modal */}
      {notifyData && (
        <>
          {/* Semi-transparent backdrop */}
          <div
            className="modal-backdrop show"
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1040
            }}
            onClick={() => setNotifyData(null)}
          />

          {/* Centered Modal */}
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{
              zIndex: 1041,
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{
                maxWidth: '450px',
                width: '85%',
                margin: '0 auto'
              }}
            >
              <div className="modal-content theme-container custom-shadow">
                <div className="modal-header">
                  <h5 className="modal-title fnt16 fw-600">
                    Change Notification
                    <div className="fnt12 text-secondary">
                      {process.env.REACT_APP_NOTIFY_TO_EMAIL}
                    </div>
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setNotifyData(null)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <div className="row">
                    {headers.map((header, index) => (
                      <div key={header} className={`col-${index < 3 ? '6' : '6'} mb-1`}>
                        <div className="form-label fnt13 fw-500 mb-0">
                          {header}
                        </div>
                        <div className="fnt12 text-secondary mb-1">
                          {notifyData[header] || "-"}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-3">
                    <textarea
                      className="form-control form-control-sm fnt12"
                      id="notifyDescription"
                      rows="3"
                      placeholder="Write a Notification Message.."
                      value={notifyDescription}
                      onChange={(e) => setNotifyDescription(e.target.value)}
                      style={{
                        backgroundColor: 'var(--card-container-bg)',
                        color: 'var(--primary-text)',
                        borderColor: 'var(--bs-border-color)'
                      }}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm fnt12 fw-500"
                    onClick={() => setNotifyData(null)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm fnt12 fw-500"
                    onClick={handleSendNotify}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Show Sent Details Modal */}
      {showSentDetails && (
        <>
          {/* Semi-transparent backdrop */}
          <div
            className="modal-backdrop show"
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1042 // Higher z-index to appear above the send modal
            }}
            onClick={() => setShowSentDetails(null)}
          />

          {/* Centered Modal */}
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{
              zIndex: 1043, // Higher z-index to appear above the send modal
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'auto'
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{
                maxWidth: '450px',
                width: '85%',
                margin: '0 auto'
              }}
            >
              <div className="modal-content theme-container custom-shadow">
                <div className="modal-header">
                  <h5 className="modal-title fnt16 fw-600">
                    Sent Notification Details
                    <div className="fnt12 text-secondary">
                      Mail To: {process.env.REACT_APP_NOTIFY_TO_EMAIL}
                    </div>

                    <div className="fnt12 text-secondary mt-1">
                      Sent At: {showSentDetails?.sentEmailData[0]?.createdAt ?
                        new Date(showSentDetails?.sentEmailData[0].createdAt).toLocaleString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true
                        }) :
                        'No date available'}
                    </div>

                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSentDetails(null)}
                    aria-label="Close"
                  />
                </div>

                <div className="modal-body">
                  <div className="row gx-2 gy-1">
                    {headers.map((header, index) => (
                      <div key={header} className={`col-${index < 3 ? '6' : '6'}`}>
                        <div className="d-flex flex-column">
                          <div className="form-label fnt13 fw-500 mb-0">
                            {header}
                          </div>
                          <div className="fnt12 text-secondary mb-1">  {/* Removed mt-1 */}
                            {showSentDetails[header] || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {showSentDetails.sentEmailData && showSentDetails.sentEmailData.length > 0 && (
                    <div className="mt-2">
                      <p className="fnt14 fw-600 mb-0">Notification Message</p>
                      <p className="fnt12 text-secondary ">
                        {showSentDetails.sentEmailData[0].description}
                      </p>

                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm fnt12 fw-500"
                    onClick={() => setShowSentDetails(null)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}






      {isLoading && <GlobalLoader />}

      <SuccessPopup
        type={successMessage.includes("Successfully") ? "success" : "error"}
        show={showSuccessPopup}
        message={successMessage}
        onClose={() => setShowSuccessPopup(false)}
      />

    </div>
  );
};

export default DataTable;






